// extracted by mini-css-extract-plugin
export default {"wrapper":"intro_wrapper__fIg8y","intro":"intro_intro__JKMZ2","title":"intro_title__HYyL3","controls":"intro_controls__srICc","button":"intro_button__lOAUa"};